@use "styles/abstracts/variables" as v;
@use "styles/abstracts/mixins/typography" as t;
@use "styles/abstracts/mixins/common" as m;

.card {
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 16px 0;
    background-color: v.$palette-white;
    border-radius: 16px;
    box-shadow: v.$shadow2;
}

.header {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-end;
    gap: 24px;
    padding: 0 24px;
}

.selectField {
    display: flex;
    flex-direction: column;
    gap: 8px;
    width: 360px;
    max-width: 100%;

    > div {
        width: 100%;
    }
}

.selectFieldNarrow {
    display: flex;
    flex-direction: column;
    gap: 8px;
    width: 160px;

    > div {
        width: 100%;
    }
}

.label {
    @include t.text(10px, 12px, 700);
    color: v.$palette-gray-900;
    text-transform: uppercase;
    letter-spacing: 0.6px;
}

.actions {
    display: flex;
    gap: 16px;
    margin-left: auto;
    padding-bottom: 8px;
}

.body {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    padding: 0 24px;
}

.image {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 130px;
    flex-shrink: 0;

    img {
        max-width: 100%;
        max-height: 100%;
        object-fit: contain;
    }

    @include m.media(v.$container-tablet, 'min') {
        width: 180px;
    }
}

.fields {
    display: flex;
    flex-direction: column;
    gap: 16px;
    min-width: 0;
}

.row {
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
    align-items: flex-start;

    > * {
        width: 100%;

        @include m.media(v.$container-tablet, 'min') {
        width: 160px;
        }
    }
}

.counterField {
    display: flex;
    flex-direction: column;
    gap: 8px;
    width: 100%;

    @include m.media(v.$container-tablet, 'min') {
        width: 160px;
    }
}

.counter {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    box-sizing: border-box;
    width: 100%;
    height: 48px;
    padding: 8px;
    background-color: v.$palette-white;
    border: 1px solid v.$palette-dirty-50;
    border-radius: 6px;
    @include m.media(v.$container-tablet, 'min') {
        width: 160px;
    }
}

.counterBtn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;
    padding: 0;
    color: v.$palette-gray-900;
    font-size: 18px;
    line-height: 1;
    background: transparent;
    border: none;
    cursor: pointer;

    &:disabled {
        opacity: 0.4;
        cursor: default;
    }
}

.counterValue {
    width: 72px;
    text-align: center;
    @include t.text(14px, 22px, 400);
    color: v.$palette-gray-900;
}

.unitIcon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 16px;
    height: 16px;
    flex-shrink: 0;
    overflow: hidden;

    img {
        display: block;
        width: 13px;
        height: 10px;
        object-fit: contain;
    }
}

.unitMenu {
    border-radius: 6px !important;
    box-shadow: v.$shadow2 !important;
}

.unitOption {
    border-radius: 6px !important;
}

.groups {
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 0 24px;
}

.groupsTitle {
    @include t.text(14px, 22px, 600);
    color: v.$palette-gray-900;
}

.groupList {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    align-items: center;
}

.groupChip {
    display: flex;
    align-items: center;
    gap: 10px;
    height: 38px;
    padding: 6px 16px;
    color: v.$palette-white;
    @include t.text(14px, 22px, 500);
    border: none;
    border-radius: 35px;
    background-color: v.$palette-orange-2;

    @media (pointer: fine) {
        &:hover {
            background-color: v.$palette-orange-3;
        }
    }
    cursor: pointer;
    font-family: v.$primary-font;
}

.chipIcon {
    display: block;
    width: 16px;
    height: 16px;
    flex-shrink: 0;
}

.addGroupWrap {
    position: relative;
}

.addGroup {
    display: flex;
    align-items: center;
    gap: 10px;
    height: 38px;
    padding: 6px 16px;
    color: v.$palette-orange-2;
    @include t.text(14px, 22px, 600);
    background-color: v.$palette-orange-4;

    @media (pointer: fine) {
        &:hover {
            color: v.$palette-orange-2;
            background-color: v.$palette-orange-4;
        }
    }
    border: none;
    border-radius: 35px;
    cursor: pointer;
    font-family: v.$primary-font;
}

.groupPicker {
    position: absolute;
    top: calc(100% + 8px);
    left: 0;
    z-index: 12;
    box-sizing: border-box;
    width: 360px;
    max-width: min(360px, 80vw);
    max-height: 240px;
    padding: 4px;
    overflow: auto;
    background-color: v.$palette-white;
    border-radius: 10px;
    box-shadow: v.$shadow1;
}

.groupPickerList {
    margin: 0;
    padding: 0;
    list-style: none;
    display: flex;
    flex-direction: column;
}

.groupPickerItem {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    box-sizing: border-box;
    width: 100%;
    height: 38px;
    padding: 8px 12px;
    color: v.$palette-gray-900;
    @include t.text(14px, 22px, 400);
    text-align: left;
    background: transparent;
    border: none;
    border-radius: 6px;
    cursor: pointer;
    font-family: v.$primary-font;

    @media (pointer: fine) {
        &:hover {
            color: v.$palette-orange-2;
            background-color: v.$palette-orange-4;
        }
    }
}

.groupPickerItemActive {
    color: v.$palette-orange-2;
    background-color: v.$palette-orange-4;
}

.groupPickerLabel {
    flex: 1;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.checkboxReadonly {
    display: inline-flex;
    flex-shrink: 0;
    pointer-events: none;
}
